module.exports = __webpack_public_path__ + "static/media/icon-linkedin.b546f266.svg";